import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../../i18n/i18n";
import { SummaryTab } from "./summaryTab";
import { ChargingTrackingTab } from "./chargingTrackingTab";
import { LinkyConnectionsTab } from "./linkyConnectionsTab";

export const ElectricCharging = (props: {
  basePath: "/home" | "/departments";
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const { basePath } = props;

  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "summary",
  );

  const tabs = useMemo(
    () => [
      {
        name: "summary",
        title: t("electric_charging.tab.summary"),
      },
      {
        name: "charging_tracking",
        title: t("electric_charging.tab.charging_tracking"),
      },
      {
        name: "linky_connections",
        title: t("electric_charging.tab.linky_connections"),
      },
    ],
    [t],
  );

  useEffect(() => {
    if (import.meta.env["VITE_TARGET_ENV"] === "production") {
      navigate(basePath);
    }
  }, [navigate, basePath]);

  useEffect(() => {
    if (selectedTab) {
      navigate(`${basePath}/electric_charging/${selectedTab}`);
    }
  }, [navigate, selectedTab, basePath]);

  return (
    <PageDS
      title={t("electric_charging.title")}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={1.5} />
        </>
      }
      supportButton={{
        showMail: true,
      }}
    >
      <SummaryTab />
      <ChargingTrackingTab />
      <LinkyConnectionsTab />
    </PageDS>
  );
};
